<template>
	<div v-if="loading">
		<div class="row">
			<div class="col-12">
				<label class="font28 font500"><mdb-icon icon="book" /> ข้อมูลการใช้งาน</label>
			</div>
		</div>
		<div class="row mt-3">
			<div class="align-self-center ml-3">วัน / เวลา</div>
			<div class="align-self-center col-12 col-md-3">
				<date-picker class="input-date" valueType="format" type="datetime" lang="en" v-model="dateselect1"></date-picker>
			</div>
			<div class="align-self-center ml-3">ถึงวันที่</div>
			<div class="col-12 col-md-3">
				<date-picker class="input-date" valueType="format" type="datetime" lang="en" v-model="dateselect2"></date-picker>
			</div>
		</div>
		<div class="row mt-2">
			<div class="align-self-center ml-3">เลือกการค้นหา</div>
			<div class="col-12 col-md-3 p-2">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text" id="basic-addon">
							<mdb-icon far icon="edit" />
						</span>
					</div>
					<input type="text" class="form-control" v-model="searchTxt" aria-describedby="basic-addon" width="80%" />
				</div>
			</div>

			<div class="col-12 col-md-4 py-1">
				<button type="button" class="btn btn-search color_white font12" style="font-weight:400; margin-left:-8px" @click="Search()"><i class="fab fa-sistrix"></i> Search</button>
				<button type="button" class="btn btn-cancel color_white font12" style="font-weight:400;"><i class="fas fa-times"></i> Cancel</button>
			</div>
		</div>

		<div>
			<mdb-datatable :arrows="true" :data="data" striped bordered :searching="false" scrollY maxHeight="450px" />
		</div>

		<!-- <div class="border-detail p-0 mt-3">
			<div class="row">
				<div class="col-12">
					<div style="max-height:350px; overflow-y:auto; overflow-x:auto;">
						<div class="row justify-content-center text-center color_orange" style="min-width:1200px;">
							<span class="col py-3 pr-2" style="max-width:110px;  border-right: 0.5px solid #cccccc;">#</span>
							<span class="col py-3" style="border-right: 0.5px solid #cccccc;">รายการ</span>
							<span class="col py-3" style="border-right: 0.5px solid #cccccc;">วันที่ เวลา</span>
							<span class="col py-3" style="border-right: 0.5px solid #cccccc;">IP</span>
						</div>
						<div class="hr-horizontal mb-2"></div> 
						<div class="row justify-content-center text-center font14" style="min-width:1200px;">
							<span class="col pr-2 pb-2" style="max-width:110px; border-right: 0.5px solid #cccccc;">1</span>
							<span class="col pb-2 text-left" style="border-right: 0.5px solid #cccccc;">Login</span>
							<span class="col pb-2" style="border-right: 0.5px solid #cccccc;">20/7/2020 11:20</span>
							<span class="col pb-2" style="border-right: 0.5px solid #cccccc;">185.23.22.236 </span>
						</div>
						<div class="row justify-content-center text-center font14" style="min-width:1200px;">
							<span class="col pr-2 pb-2" style="max-width:110px; border-right: 0.5px solid #cccccc;">2</span>
							<span class="col pb-2 text-left" style="border-right: 0.5px solid #cccccc;">Export Summary รายงาน > รายงานย้อนหลัง > การส่งข้อความ</span>
							<span class="col pb-2" style="border-right: 0.5px solid #cccccc;">20/7/2020 13:50</span>
							<span class="col pb-2" style="border-right: 0.5px solid #cccccc;">185.23.22.154 </span>
						</div>
					</div>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
	import {mapGetters, mapActions} from 'vuex'
	import DatePicker from 'vue2-datepicker'
	import moment from 'moment'
	export default {
		name: 'Usagedata',
		components: {
			DatePicker,
		},
		data() {
			return {
				dateselect1: new Date(),
				dateselect2: new Date(),
				searchTxt: '',
				loading: false,
				data: {
					columns: [
						{
							label: '#',
							field: 'id2',
							sort: true,
						},
						{
							label: 'Description',
							field: 'event',
							sort: true,
						},
						{
							label: 'User Name',
							field: 'username',
							sort: true,
						},
						{
							label: 'Event Date',
							field: 'date',
							sort: true,
							format: (value) => {
								return moment(value).format('DD/MM/YYYY HH:mm:ss')
							},
						},
						{
							label: 'IP Address',
							field: 'ip_address',
							sort: true,
						},
					],
					rows: null,
				},
			}
		},
		computed: {
			...mapGetters({
				isLogin: 'isLogin',
				user: 'user',
				token: 'token',
			}),
		},
		methods: {
			...mapActions({
				storeLogin: 'login',
				storeLoout: 'logout',
				loadsession: 'loadsession',
				callApiMotherFucker: 'callApiMotherFucker',
			}),
			async Search() {
				this.loading = false
				if (this.searchTxt == '') {
					await this.callApiMotherFucker({
						method: 'post',
						path: '/user_log/All',
						data: {},
					}).then((res) => {
						if (res.payload) {
							this.data.rows = this.$add_index(res.payload)
							this.loading = true
						}
					})
				} else {
					let paylod2 = {
						date_start: this.dateselect1,
						date_end: this.dateselect2,
						text: this.searchTxt,
					}
					await this.callApiMotherFucker({
						method: 'post',
						path: '/user_log/query',
						data: paylod2,
					}).then((res) => {
						if (res.payload) {
							this.data.rows = this.$add_index(res.payload)
							this.loading = true
						}
					})
				}
			},
		},
		async mounted() {
			this.dateselect1 = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
			this.dateselect2 = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
			await this.callApiMotherFucker({
				method: 'post',
				path: '/user_log/All',
				data: {},
			}).then((res) => {
				this.loading = true
				if (res.payload) {
					this.data.rows = this.$add_index(res.payload)
				}
			})
		},
	}
</script>

<style></style>
